export default "/images/35f1a913b25da4e0003854c43cc4566e.avif";